<template>
  <div @click="reward.get('isComingSoon') ? null : $emit('activated')"
    :class="`card cc-reward card-slim ${reward.get('isComingSoon') ? 'no-shadow' : null}`"
    :style="`background-image: url('${reward.get('image') || '/images/reward.jpeg'}'); `">
    <div class="overlay"></div>
    <div class="card-header">
      <h3>{{ reward.get('name') }}</h3>
      <h3 class="cost"></h3>
    </div>
    <span></span>

    <div class="card-footer"></div>
  </div>
</template>
<script>
export default {
  name: 'reward-listing',
  props: ["reward", 'clickAction'],
  data() {
    return {
      business: null
    }
  },
  mounted() {

  }
}
</script>